export default {
  namespaced: true,
  state: {
    chartData: {
      shows: {
        index: 0,
        title: 'Показы',
        total: 0,
        chartData: {},
        chartStepY: 0,
        chartType: 'line'
      },
      clicks: {
        index: 1,
        title: 'Клики',
        total: 0,
        chartData: {},
        chartStepY: 0,
        chartType: 'line'
      },
      costs: {
        index: 2,
        title: 'Расходы с НДС, руб.',
        total: 0,
        chartFill: true,
        chartData: {},
        chartStepY: 0
      },
      cpc: {
        index: 3,
        title: 'CPC, руб.',
        total: 0,
        chartData: {},
        chartStepY: 0
      },
      conversions: {
        index: 4,
        title: 'Конверсии',
        total: 0,
        chartData: {},
        chartStepY: 0
      },
      cpl: {
        index: 5,
        title: 'CPL, руб.',
        total: 0,
        chartData: {},
        chartStepY: 0,
        chartType: 'line',
        chartSmooth: true
      }
    }
  },
  getters: {
    getChartData (state) {
      return state.chartData
    }
  }
}
